"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productsReducer = void 0;
const ts_pattern_1 = require("ts-pattern");
const state_1 = require("../redux/state");
const utils_1 = require("../redux/utils");
const actions_1 = require("./actions");
const productsReducer = (state) => (action) => (0, ts_pattern_1.match)(action)
    .with({ type: 'SET_PRODUCTS' }, _action => state.update(state_1.stateKeys.products, _state => (0, utils_1.returnStateLoadingFalse)(_state, _action)))
    .with({ type: 'SET_PRODUCTS_ERROR' }, _action => state.update(state_1.stateKeys.products, _state => ({
    ..._state,
    error: _action.payload
})))
    .with({ type: 'UPDATE_PRODUCTS' }, _action => state.update(state_1.stateKeys.products, _state => ({
    ..._state,
    loading: false,
    // we want to deep merge so we don't overwrite anything that is already defined with something that is undefined
    value: (0, actions_1.updateProducts)(_state.value)(_action.payload)
})))
    .with({ type: 'UPDATE_PRODUCT_PRICE' }, _action => state.update(state_1.stateKeys.products, _state => {
    const { masterSku, price, discountedPrice } = _action.payload;
    const targetProduct = _state.value.get(masterSku);
    return targetProduct
        ? {
            ..._state,
            value: _state.value.set(masterSku, {
                ...targetProduct,
                discountedPrice,
                lastFetched: new Date().getTime(),
                price
            })
        } : _state;
}))
    .exhaustive();
exports.productsReducer = productsReducer;
//# sourceMappingURL=reducer.js.map